// 用户vuex模块
import {
  getUserInfoAndAccessTokenReq,
  getUserInfoAndAccessTokenReq2,
} from "@/api/login";
const state = {
  userInfo: JSON.parse(localStorage.getItem("userInfo")),
  token: localStorage.getItem("token"),
};

const mutations = {
  SET_TOKEN(state, data) {
    // 一份数据存Vuex
    state.token = data;
    // 一份数据存入本地
    localStorage.setItem("token", data);
  },
  SET_USERINFO(state, data) {
    // 一份数据存Vuex
    state.userInfo = data;
    // 一份数据存入本地
    localStorage.setItem("userInfo", JSON.stringify(data));
  },
};

const actions = {
  A_Login({ commit }, value) {
    return new Promise(async (resolve) => {
      let res = await getUserInfoAndAccessTokenReq2();
      let { code, extendData, data } = res.data;
      if (code === 200) {
        commit("SET_TOKEN", "Bearer " + extendData);
        commit("SET_USERINFO", data);
        resolve();
      }
      // let res = await getUserInfoAndAccessTokenReq({ code: value });
      // let { code, extendData, data } = res.data;
      // if (code === 200) {
      //   commit("SET_TOKEN", "Bearer " + extendData);
      //   commit("SET_USERINFO", data);
      //   resolve();
      // }
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
